import ContinuePage from "@components/ContinuePage"

export default function StyleSnapshotPage() {
  return <ContinuePage emoji="🪞" translationKey="abFeedbackV1.styleSnapshot" />
}
